/**
 * SessionExpiredHandler — turns the authClient's session-expired event into
 * UX: a warning notice + redirect to /login with a return path
 * (silent-session-expiry-fix spec).
 */

import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { SESSION_EXPIRED_EVENT } from '../auth/authClient';
import { useNotification } from '../contexts/NotificationContext';

export function SessionExpiredHandler(): null {
  const navigate = useNavigate();
  const location = useLocation();
  const { showWarning } = useNotification();

  useEffect(() => {
    const handler = () => {
      showWarning('Session expired — please sign in again');
      const next = encodeURIComponent(location.pathname);
      navigate(`/login?next=${next}&expired=1`, { replace: true });
    };
    window.addEventListener(SESSION_EXPIRED_EVENT, handler);
    return () => window.removeEventListener(SESSION_EXPIRED_EVENT, handler);
  }, [navigate, location.pathname, showWarning]);

  return null;
}

export default SessionExpiredHandler;
